<template>
  <div>
    <a-modal
      v-model="showModal"
      width="587px"
      :maskClosable="false"
      :centered="true"
      :closable="false"
      class="onboarding-modal"
      :dialog-style="{ margin: '0px', width: '100px !important' }"
      @ok="() => (showModal = false)"
    >
      <template slot="title">
        <div class="d-flex align-items-center">
          <font-awesome-icon size="1x" :icon="['fal', 'times']" class="show-in-mobile font-black mr-3 font20" @click="showModal = false" />
          <h5 class="fw700 font20 gray700 mb-0">Add a Condition</h5>
          <a-button
            key="submit"
            type="primary"
            :disabled="!selectedCircle"
            @click="save()"
            class="primary-button saveButton font-white show-in-mobile ml-auto"
            :style="{
              background: getPrimaryColor(),
              opacity: selectedCircle ? '1' : '0.3',
            }"
          >
            Save
          </a-button>
          <font-awesome-icon size="1x" :icon="['fal', 'times']" class="hide-in-mobile font-black ml-auto font20 cp" @click="showModal = false" />
        </div>
      </template>
      <template slot="footer">
        <!-- <button
          key="cancel"
          @click="showModal = false"
          :style="{
            background: '#fff',
            color: '#000',
            padding: '8px 40px',
            'border-radius': '25px'
          }"
          class="primary-button saveButton hide-in-mobile"
          >Cancel</button
        > -->
        <a-button
          key="submit"
          type="primary"
          @click="save()"
          :disabled="!selectedCircle"
          class="primary-button saveButton hide-in-mobile"
          :style="{
            background: getPrimaryColor(),
            opacity: selectedCircle ? '1' : '0.3',
          }"
        >
          <span :style="{ color: '#fff !important' }">Save</span>
        </a-button>
      </template>
      <div class="dovemed-wrapper text-center signup-page symptoms-body">
        <div class="signup-container">
          <div class="row mb-4">
            <div class="col-12 text-left  ">
              <label class="font-weight-bold">Search for Conditions.</label>
              <a-select
                show-search
                :size="'large'"
                placeholder="ex. abdominal pain etc.."
                allowClear
                v-model="selectedCircle"
                :default-value="defaultCircle"
                :filterOption="false"
                class="w-100"
                @search="searchOtherCircles"
                @change="handleOtherCircle"
              >
                <a-select-option v-for="circle in circleList" :key="circle.id" :value="circle.display_name">
                  {{ circle.display_name }}
                </a-select-option>
              </a-select>
              <div class="mt-4 mb-2">
                <label class="font-weight-bold">Symptoms</label>
                <a-select
                  mode="multiple"
                  :size="'large'"
                  placeholder="ex. abdominal pain etc.."
                  allowClear
                  :filterOption="false"
                  :value="symptoms ? symptoms.map(ele => ele.display_name) : undefined"
                  notFoundContent=""
                  :disabled="selectedCircle ? false : true"
                  class="w-100"
                  @search="searchSymptoms"
                  @change="handleSymptoms"
                >
                  <a-select-option v-for="symptom in symptomsList" :key="symptom.id" :value="symptom.display_name">
                    {{ symptom.display_name }}
                  </a-select-option>
                </a-select>
              </div>
              <div v-if="symptoms && selectedCircle" class="mt-4">
                <!-- <div class="symptom-effectiveness"> -->
                <div v-for="(symptom, index) in symptoms" :key="index">
                  <div class="symptoms-lists mt-2">
                    <div>{{ symptom.display_name }}</div>
                    <div class="symptom-radio">
                      <div>
                        <input :style="{ cursor: 'pointer' }" type="radio" value="0" :checked="symptom.effectiveness === '0'" :name="symptom.display_name" @click="handleRadioChange" />
                        <label>Mild</label>
                      </div>
                      <div>
                        <input :style="{ cursor: 'pointer' }" type="radio" value="50" :checked="symptom.effectiveness === '50'" :name="symptom.display_name" @click="handleRadioChange" />
                        <label>Moderate</label>
                      </div>
                      <div>
                        <input :style="{ cursor: 'pointer' }" type="radio" value="100" :checked="symptom.effectiveness === '100'" :name="symptom.display_name" @click="handleRadioChange" />
                        <label>Severe</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </a-modal>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
const AppRepository = RepositoryFactory.get("app")
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "AdditionalConditions",
  data() {
    return {
      showModal: false,
      key: null,
      title: null,
      data: null,
      symptoms: [],
      savedSymptoms: [],
      savedSymptomsValues: [],
      otherSymptoms: null,
      load: false,
      symptomsList: [],
      otherSymptomsList: [],
      other_symptoms: [],
      selectedCircle: undefined,
      circleList: [],
      fetchOther: null,
      defaultSymptoms: undefined,
      defaultSideEffects: undefined,
      defaultCircle: undefined,
      previousSymptoms: [],
    }
  },

  created() {
    this.searchOtherCircles("a")
  },

  methods: {
    show(key, symtp, othrSympt, init) {
      console.warn("AdditionalConditions.vue is shown")

      this.key = key
      this.fetchOther = init

      this.showModal = true
      // this.defaultCircle = symtp ? symtp[0].circle_name : null;

      this.previousSymptoms = symtp
      console.log("this.prevouse symptoms", this.previousSymptoms)
      // this.defaultSymptoms = symtp.map(ele => ele.display_name);

      this.symptoms = []
      this.searchSymptoms()
      this.searchOtherCircles("a")
    },
    hide() {
      this.symptoms = undefined
      this.selectedCircle = undefined
      this.showModal = false
    },
    handleRadioChange(e) {
      this.symptoms.map(smpt => {
        if (e.target.name === smpt.display_name) {
          return (smpt.effectiveness = e.target.value)
        }
      })
    },
    handleRadioChangeSideEffects(e) {
      this.otherSymptoms.map(smpt => {
        if (e.target.name === smpt.display_name) {
          return (smpt.effectiveness = e.target.value)
        }
      })
    },
    searchSymptoms(value = "a") {
      AppRepository.searchSymptoms(value, this.currentCircle).then(res => {
        this.symptomsList = res.data.data.circle_sideeffects ? [...res.data.data.circle_sideeffects] : []
        this.otherSymptomsList = res.data.data.other_sideeffects ? [...res.data.data.other_sideeffects] : []
      })
    },

    handleSymptoms(value) {
      this.symptoms = value.map(smtp => {
        const oldSymptom = this.symptoms.find(symt => {
          return symt.display_name === smtp
        })
        return {
          display_name: smtp,
          effectiveness: oldSymptom ? oldSymptom.effectiveness : "50",
          circle_name: this.selectedCircle,
        }
      })
      this.symptomsList.length = 0
    },

    handleOtherSymptoms(value) {
      this.otherSymptoms = value.map(smtp => {
        return {
          display_name: smtp,
          effectiveness: "50",
          circle_name: this.selectedCircle,
        }
      })
    },
    handleTags(value) {
      this.data = value
    },
    handleOtherCircle(value) {
      this.selectedCircle = value

      if (this.symptoms) {
        this.symptoms.map(ele => {
          ele.circle_name = this.selectedCircle
          return ele
        })
      }
      if (this.otherSymptoms) {
        this.otherSymptoms.map(ele => {
          ele.circle_name = this.selectedCircle
          return ele
        })
      }
    },
    searchOtherCircles(value) {
      AppRepository.getOtherConditions(value)
        .then(res => {
          this.circleList = res.data.data
        })
        .catch(err => {
          console.log(err)
        })
    },

    save() {
      console.log(this.symptoms, this.previousSymptoms, "both symptoms")
      const payload = {
        [this.key]: this.symptoms ? (this.previousSymptoms ? [...this.symptoms, ...this.previousSymptoms] : [...this.symptoms]) : [],
      }
      console.log(payload, "additional conditions payload")
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`,
      }

      this.symptoms.map(item => {
        return this.previousSymptoms.map(ele => {
          if (item.circle_name === ele.circle_name) {
            this.flag = false
          }
        })
      })

      if (this.symptoms.length) {
        if (this.flag) {
          this.$http
            .put(`${process.env.BASE_API_URL}/${this.authUser.user.role === "patient" ? "normaluser" : this.authUser.user.role}/?user_id=${this.authUser.user.id}`, payload, { headers })
            .then(res => {
              this.$emit("refresh")
              this.$store.commit("Posts/setPercent", true)
              this.hide()
            })
            .catch(err => {})
        } else {
          this.$notification.error({
            message: "Error",
            description: "Condition is already added.",
          })
        }
      } else {
        this.$notification.error({
          message: "Error",
          description: "You need to add atleast one symptom before submitting.",
        })
      }
      this.flag = true
    },
  },
}
</script>

<style lang="scss" scoped>
.symptoms-lists {
  display: flex;
  justify-content: space-between;
  padding: 16px;
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
  background: rgba(37, 103, 237, 0.05);
  border-radius: 5px;

  @media screen and (max-width: 900px) {
    padding: 12px;
    flex-direction: column;
  }
  .ant-radio-group {
    .ant-radio-wrapper {
      .ant-radio-checked {
        .ant-radio-inner::after {
          color: red;
          background: green;
        }
      }
    }
  }
}

.symptom-effectiveness {
  height: 300px;
  overflow: auto;
}

.symptom-radio {
  width: 50%;
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 900px) {
    margin-top: 10px;
    width: 100%;
  }
}
.dovemed-button {
  padding: 12px 40px;

  @media screen and (max-width: 900px) {
    padding: 12px 32px;
  }
}
.symptoms-body {
  @media screen and (max-width: 900px) {
    height: 80vh;
  }
}

.saveButton {
  color: #fff;
  padding: 12px 24px;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/profile/AdditionalConditions.vue